import { isPlatformServer } from '@angular/common';
import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID, REQUEST } from '@angular/core';

export const ssrCookieInterceptor: HttpInterceptorFn = (request, next) => {
  const platformId = inject(PLATFORM_ID);
  if (!isPlatformServer(platformId)) return next(request);

  const incomingRequest = inject(REQUEST, { optional: true });
  const cookieHeader = incomingRequest?.headers.get('cookie');
  if (!cookieHeader) return next(request);

  return next(request.clone({ setHeaders: { cookie: cookieHeader } }));
};
